export default function parseQueryParams(data) {
    return data ? Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&') : '';
}